import TypicalAssetAllocation from './TypicalAssetAllocation';
import RiskSummary from './RiskSummary';
import ForecastGrossInvReturns from './ForecastGrossReturns';

export default {
  TypicalAssetAllocation,
  RiskSummary,
  ForecastGrossInvReturns
};
